import React from 'react';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  onCancel, 
  onThirdAction = null, // Optional third action (e.g., "Save and Exit")
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  thirdActionText = 'Save and Exit', // Text for third action button
  variant = 'default' 
}) => {
  if (!isOpen) return null;

  const isDanger = variant === 'danger';
  const hasThirdAction = onThirdAction !== null && onThirdAction !== undefined;
  
  // (debug log removed)

  return (
    <div className="ds-modal-overlay" onClick={onClose}>
      <div className="ds-modal" onClick={(e) => e.stopPropagation()}>

        {/* Icon */}
        <div className="text-center mb-5">
          <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 ${
            isDanger ? 'bg-red-50' : 'bg-stone-100'
          }`}>
            {isDanger ? (
              <svg className="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            ) : (
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: 'var(--brand-charcoal)' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
          </div>
          <h2 className="text-xl font-bold text-center mb-2" style={{ color: 'var(--brand-charcoal)' }}>{title}</h2>
          <p className="text-sm text-center leading-relaxed ds-text-muted">{message}</p>
        </div>

        {/* Actions */}
        <div className={`flex gap-3 ${hasThirdAction ? 'flex-col' : ''}`}>
          {hasThirdAction ? (
            <>
              <div className="flex justify-center">
                <button
                  onClick={() => { if (onThirdAction) onThirdAction(); onClose(); }}
                  className="ds-btn-primary px-8 py-3 text-base"
                >
                  {thirdActionText}
                </button>
              </div>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={() => { if (onCancel) onCancel(); onClose(); }}
                  className="ds-btn-ghost px-5 py-2 text-sm"
                >
                  {cancelText}
                </button>
                <button
                  onClick={() => { if (onConfirm) onConfirm(); onClose(); }}
                  className={isDanger ? 'ds-btn-danger px-5 py-2 text-sm' : 'ds-btn-ghost px-5 py-2 text-sm'}
                >
                  {confirmText}
                </button>
              </div>
            </>
          ) : (
            <>
              <button
                onClick={() => { if (onCancel) onCancel(); onClose(); }}
                className="ds-btn-ghost flex-1 py-3 text-sm"
              >
                {cancelText}
              </button>
              <button
                onClick={() => { if (onConfirm) onConfirm(); onClose(); }}
                className={isDanger ? 'ds-btn-danger flex-1 py-3 text-sm' : 'ds-btn-primary flex-1 py-3 text-sm'}
              >
                {confirmText}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

